import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import wedding from '../assets/home/wedding5.jpg';
import offer1 from '../assets/offer/5.jpg';
import offer2 from '../assets/offer/Glintz(115).jpg';
import offer3 from '../assets/offer/Glintz(121).jpg';
import offer4 from '../assets/offer/Glintz(124).jpg';
import offer5 from '../assets/offer/Glintz(141).jpg';
import offer6 from '../assets/offer/Glintz(146).jpg';
import offer7 from '../assets/offer/GlintzPhotographywedding.jpg';
import offer8 from '../assets/offer/GlintzWeddingsBECCATOBI-10.jpg';
import offer9 from '../assets/offer/GlintzWeddingsBECCATOBI-11.jpg';
import offer10 from '../assets/offer/10a.jpg';

const deliverables = [
  {
    title: "Expert, Unobtrusive Coverage",
    body: "High-end photography that blends seamlessly into your event. We capture the best angles without ever being in the way.",
  },
  {
    title: "Complete Day Coverage",
    body: "From bridal preparation through to the first dance — every significant moment, documented with precision and care.",
  },
  {
    title: "Documentary-Grade Colour Grading",
    body: "Every single image is individually refined for a clean, timeless, luxury aesthetic.",
  },
  {
    title: "The High-Resolution Archive",
    body: "A beautifully curated, bespoke private digital portfolio, delivered seamlessly so you can print and share instantly.",
  },
  {
    title: "Upgrade Your Package",
    body: "Tailor your commission to include after-party coverage, a premium photo book, custom wall frames, and more — your day, your vision.",
  },
];

const today = new Date().toISOString().split('T')[0];

const Offer = () => {
  const [form, setForm] = useState({ names: '', email: '', weddingDate: '', venue: '' });
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/booking`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ portfolioType: 'wedding-offer', ...form }),
      });
      const data = await res.json();
      if (data.success) {
        navigate('/thank-you', { state: { source: 'offer' } });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <>
      <Helmet>
        <title>£999 UK Wedding Photography Offer | Glintz Photography</title>
        <meta
          name="description"
          content="Limited offer: Premium documentary-style UK wedding photography from £999. Complete day coverage, luxury colour grading, and a bespoke private digital portfolio. Offer expires August 30th."
        />
      </Helmet>

      <Navbar />

      {/* ── SECTION 1: HERO ──────────────────────────────────────────────────── */}
      <section className="relative min-h-screen overflow-hidden bg-black flex items-end">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${wedding})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/60 z-10" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/20 z-10" />

        {/* Offer badge */}
        <div className="absolute top-[140px] right-6 xl:right-44 z-20 border border-white/30 px-5 py-4 text-center">
          <p
            className="text-white/80 uppercase tracking-[.3em] text-[10px] mb-1"
            style={{ fontFamily: 'Muli, sans-serif' }}
          >
            Limited Offer
          </p>
          <p className="text-white text-3xl xl:text-4xl font-light tracking-tight">£999</p>
          <p
            className="text-white/80 uppercase tracking-[.2em] text-[10px] mt-1"
            style={{ fontFamily: 'Muli, sans-serif' }}
          >
            Expires August 30th
          </p>
        </div>

        <div className="relative z-20 w-full xl:px-44 lg:px-24 px-6 mt-40  pb-20 xl:pb-28">
          <p
            className="text-white/70 uppercase tracking-[.4em] text-xs mb-5"
            style={{ fontFamily: 'Muli, sans-serif' }}
          >
            UK Wedding Photography
          </p>
          <h1 className="text-white uppercase xl:text-5xl lg:text-4xl md:text-3xl text-2xl leading-[1.05] tracking-[.08em] mb-6 max-w-4xl">
            Exquisite UK Wedding Photography<br className="hidden xl:block" /> from £999 Premium Commission
          </h1>
          <p
            className="text-white/70 text-sm md:text-base max-w-xl leading-relaxed mb-10"
            style={{ fontFamily: 'Muli, sans-serif' }}
          >
            Breathtaking, documentary-style imagery that captures the true elegance of your day —
            without turning your celebration into an exhausting photoshoot.
          </p>
          <div>
            <a
              href="#secure"
              className="inline-block bg-white text-black px-10 py-4 text-xs tracking-[.25em] uppercase hover:bg-white/90 transition-all mb-4"
              style={{ fontFamily: 'Muli, sans-serif' }}
            >
              Check My Date &amp; Claim £999 Offer
            </a>
            <p
              className="text-white/70 text-xs tracking-[.15em]"
              style={{ fontFamily: 'Muli, sans-serif' }}
            >
              Offer strictly expires August 30th. Dates are booked on a first-come, first-served basis.
            </p>
          </div>
        </div>

        <div className="absolute bottom-8 left-6 xl:left-44 z-20 opacity-40">
          <div className="w-px h-12 bg-white/50" />
        </div>
      </section>

      {/* ── SECTION 2: VALUE PROP ────────────────────────────────────────────── */}
      <section className="bg-black border-t border-white/10 xl:px-44 lg:px-24 px-6 py-24 xl:py-32">
        <div className="grid xl:grid-cols-2 gap-16 items-start">
          <div>
            <p
              className="text-white/70 uppercase tracking-[.4em] text-xs mb-6"
              style={{ fontFamily: 'Muli, sans-serif' }}
            >
              Our Approach
            </p>
            <h2 className="text-white uppercase xl:text-5xl lg:text-4xl text-3xl tracking-[.08em] leading-tight mb-10">
              Flawless Imagery.<br />Zero Awkward Posing.
            </h2>

            <div className="space-y-6">
              <p
                className="text-white/80 text-sm md:text-base leading-relaxed"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                Whether your day is an intimate gathering or an elaborate destination affair, we are
                there from bridal preparation through to the first dance, capturing every chapter as
                it unfolds.
              </p>
              <p
                className="text-white/80 text-sm md:text-base leading-relaxed"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                You want your wedding photos to look clean, sincere, and with an artistic touch. You
                want the lighting to be perfect, the details to be sharp, and every emotion captured
                brilliantly.
              </p>
              <p
                className="text-white/80 text-sm md:text-base leading-relaxed"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                You shouldn't have to choose between stunning visual quality and actually enjoying
                your wedding day. With Glintz Photography, you get both.
              </p>
              <p
                className="text-white/80 text-sm md:text-base leading-relaxed border-l-2 border-white/20 pl-6"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                Your £999 commission includes complete coverage from bridal prep to the first dance,
                with every selected image individually refined and delivered to a bespoke private
                digital portfolio, beautifully organised and ready for you to print, share, or treasure.
              </p>
              <p
                className="text-white/80 text-sm md:text-base leading-relaxed"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                And if you want to go further, your package can be tailored to include after-party
                coverage, a premium photo book, custom wall frames, and more.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-8">
            <div
              className="overflow-hidden"
              style={{ aspectRatio: '3/4' }}
            >
              <img
                src={offer7}
                alt="Documentary wedding photography"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Clarity session CTA */}
            <div className="border border-white/30 p-8">
              <p
                className="text-white/80 uppercase tracking-[.3em] text-xs mb-3"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                Not sure what's right for your day?
              </p>
              <p
                className="text-white/70 text-sm leading-relaxed mb-6"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                Book a free 30-minute clarity session, and we'll help you figure out exactly what
                you need — no pressure, no obligation.
              </p>
              <a
                href="/contact"
                className="inline-block border border-white/40 text-white px-8 py-3 text-xs tracking-[.25em] uppercase hover:bg-white hover:text-black transition-all"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                Book My Free Clarity Session
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── SECTION 3: WHAT'S INCLUDED ───────────────────────────────────────── */}
      <section className="bg-white xl:px-44 lg:px-24 px-6 py-24 xl:py-32">
        <p
          className="text-black/70 uppercase tracking-[.4em] text-xs mb-6"
          style={{ fontFamily: 'Muli, sans-serif' }}
        >
          The Commission
        </p>
        <h2 className="text-black uppercase xl:text-5xl lg:text-4xl text-3xl tracking-[.08em] leading-tight mb-4 max-w-3xl">
          The Complete £999 Wedding Commission
        </h2>
        <p
          className="text-black/70 text-sm md:text-base max-w-xl leading-relaxed mb-16"
          style={{ fontFamily: 'Muli, sans-serif' }}
        >
          From now till August 30th, we are offering our premier wedding documentation at a
          straightforward, accessible rate.
        </p>

        <div className="grid xl:grid-cols-2 gap-px bg-gray-100 mb-16">
          {deliverables.map((item, i) => (
            <div key={i} className="bg-white p-8 xl:p-10">
              <div className="flex gap-5 items-start">
                <span className="text-black/40 text-3xl font-light leading-none shrink-0 mt-1">
                  0{i + 1}
                </span>
                <div>
                  <h3 className="text-black uppercase tracking-[.1em] text-sm font-semibold mb-3">
                    {item.title}
                  </h3>
                  <p
                    className="text-black/70 text-sm leading-relaxed"
                    style={{ fontFamily: 'Muli, sans-serif' }}
                  >
                    {item.body}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="#secure"
            className="inline-block bg-black text-white px-12 py-4 text-xs tracking-[.3em] uppercase hover:bg-black/80 transition-all"
            style={{ fontFamily: 'Muli, sans-serif' }}
          >
            Lock In My £999 Rate Now
          </a>
        </div>
      </section>

      {/* ── SECTION 4: GALLERY ──────────────────────────────────────────────── */}
      <section className="bg-black xl:px-44 lg:px-24 px-6 py-24 xl:py-32">
        <p
          className="text-white/70 uppercase tracking-[.4em] text-xs mb-6"
          style={{ fontFamily: 'Muli, sans-serif' }}
        >
          Our Work
        </p>
        <h2 className="text-white uppercase xl:text-5xl lg:text-4xl text-3xl tracking-[.08em] leading-tight mb-16 max-w-3xl">
          Real Weddings.<br />Real Moments.
        </h2>
        <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2">
          {[offer1, offer2, offer3, offer4, offer5, offer6, offer7, offer8, offer9, offer10].map((src, i) => (
            <div key={i} className="overflow-hidden" style={{ aspectRatio: '3/4' }}>
              <img
                src={src}
                alt={`Wedding photography ${i + 1}`}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </section>

      {/* ── SECTION 5: TESTIMONIAL ───────────────────────────────────────────── */}
      <section className="bg-black xl:px-44 lg:px-24 px-6 py-24 xl:py-32">
        <p
          className="text-white/70 uppercase tracking-[.4em] text-xs mb-12"
          style={{ fontFamily: 'Muli, sans-serif' }}
        >
          Trusted by Discerning UK Couples
        </p>
        <blockquote className="max-w-3xl">
          <div className="text-white/50 text-8xl font-serif leading-none mb-6">"</div>
          <p
            className="text-white xl:text-2xl lg:text-xl text-lg font-light italic leading-relaxed mb-10"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            The quality of our photos blew us away. They look like a documentary. But the best
            part? They captured the most beautiful, high-end shots while we just drank champagne
            and enjoyed our friends.
          </p>
          <cite
            className="text-white/70 text-xs uppercase tracking-[.3em] not-italic"
            style={{ fontFamily: 'Muli, sans-serif' }}
          >
            — Sarah &amp; James, London
          </cite>
        </blockquote>
      </section>

      {/* ── SECTION 6: URGENCY + FORM ────────────────────────────────────────── */}
      <section id="secure" className="bg-black border-t border-white/10 xl:px-44 lg:px-24 px-6 py-24 xl:py-32">
        <div className="grid xl:grid-cols-2 gap-16 items-start">
          {/* Urgency copy */}
          <div>
            <p
              className="text-white/70 uppercase tracking-[.4em] text-xs mb-6"
              style={{ fontFamily: 'Muli, sans-serif' }}
            >
              Don't Lose Your Date
            </p>
            <h2 className="text-white uppercase xl:text-5xl lg:text-4xl text-3xl tracking-[.08em] leading-tight mb-10">
              Your Date Will Book Out.<br />Don't Wait.
            </h2>

            <div className="space-y-6">
              <p
                className="text-white/80 text-sm md:text-base leading-relaxed"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                In the wedding industry, hesitation costs you your preferred vendors. There are only
                so many weekends in a year, and our calendar for the upcoming season is filling rapidly.
              </p>
              <p
                className="text-white/80 text-sm md:text-base leading-relaxed"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                We strictly cap the number of weddings we take to ensure our standard of quality
                never drops. Once a date is claimed, it is permanently off the market.
              </p>
              <p
                className="text-white/80 text-sm md:text-base leading-relaxed border-l-2 border-white/20 pl-6"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                This £999 offer expires on August 30th. If you wait until you have every other detail
                planned before booking your photographer, your date — and this rate — will likely be gone.
              </p>
              <p
                className="text-white/80 text-sm md:text-base leading-relaxed"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                When you find the right visual team, the best time to secure them is right now.
              </p>
            </div>

            {/* Expiry banner */}
            <div className="mt-10 border border-white/30 px-8 py-6 flex items-center justify-between">
              <div>
                <p
                  className="text-white/70 uppercase tracking-[.3em] text-[10px] mb-1"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                >
                  Offer Expires
                </p>
                <p className="text-white text-2xl font-light tracking-tight">August 30th</p>
              </div>
              <div className="h-10 w-px bg-white/10" />
              <div>
                <p
                  className="text-white/70 uppercase tracking-[.3em] text-[10px] mb-1"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                >
                  Starting From
                </p>
                <p className="text-white text-2xl font-light tracking-tight">£999</p>
              </div>
              <div className="h-10 w-px bg-white/10" />
              <div>
                <p
                  className="text-white/70 uppercase tracking-[.3em] text-[10px] mb-1"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                >
                  Booking
                </p>
                <p className="text-white text-2xl font-light tracking-tight">First-Come</p>
              </div>
            </div>
          </div>

          {/* Booking Form */}
          <div>
            <p
              className="text-white/70 uppercase tracking-[.4em] text-xs mb-8"
              style={{ fontFamily: 'Muli, sans-serif' }}
            >
              Secure Your Commission
            </p>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="flex flex-col gap-1.5">
                <label
                  htmlFor="names"
                  className="text-white/90 text-xs uppercase tracking-widest"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                >
                  Full Names
                </label>
                <input
                  id="names"
                  name="names"
                  type="text"
                  value={form.names}
                  onChange={handleChange}
                  required
                  placeholder="e.g. Sarah & James Thompson"
                  className="border border-white/60 bg-white/10 text-white placeholder-white/50 px-4 py-3 text-sm focus:outline-none focus:border-white transition"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                />
              </div>

              <div className="flex flex-col gap-1.5">
                <label
                  htmlFor="email"
                  className="text-white/90 text-xs uppercase tracking-widest"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                >
                  Email Address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="e.g. sarah@example.com"
                  className="border border-white/60 bg-white/10 text-white placeholder-white/50 px-4 py-3 text-sm focus:outline-none focus:border-white transition"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                />
              </div>

              <div className="flex flex-col gap-1.5">
                <label
                  htmlFor="weddingDate"
                  className="text-white/90 text-xs uppercase tracking-widest"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                >
                  Exact Wedding Date
                </label>
                <input
                  id="weddingDate"
                  name="weddingDate"
                  type="date"
                  value={form.weddingDate}
                  onChange={handleChange}
                  required
                  min={today}
                  className="border border-white/60 bg-white/10 text-white px-4 py-3 text-sm focus:outline-none focus:border-white transition [color-scheme:dark]"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                />
              </div>

              <div className="flex flex-col gap-1.5">
                <label
                  htmlFor="venue"
                  className="text-white/90 text-xs uppercase tracking-widest"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                >
                  UK Venue / Location
                </label>
                <input
                  id="venue"
                  name="venue"
                  type="text"
                  value={form.venue}
                  onChange={handleChange}
                  required
                  placeholder="e.g. The Midland Hotel, Manchester"
                  className="border border-white/60 bg-white/10 text-white placeholder-white/50 px-4 py-3 text-sm focus:outline-none focus:border-white transition"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                />
              </div>

              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full bg-white text-black px-10 py-4 text-xs tracking-[.3em] uppercase hover:bg-white/90 transition-all disabled:opacity-50"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                {status === 'loading' ? 'Checking Availability…' : 'Claim This Offer & Check Availability'}
              </button>

              {status === 'error' && (
                <p
                  className="text-sm text-red-400 uppercase tracking-widest text-center"
                  style={{ fontFamily: 'Muli, sans-serif' }}
                >
                  Something went wrong. Please try again or contact us directly.
                </p>
              )}

              <p
                className="text-white/60 text-xs text-center leading-relaxed"
                style={{ fontFamily: 'Muli, sans-serif' }}
              >
                Offer strictly expires August 30th. Securing your date is subject to availability.
              </p>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Offer;